import AccountIcon from '@assets/vectors/account.inline.svg';

import QuickLink from '.';

const Library: QuickLink = ({ header, description }) => {
	return {
		Icon: AccountIcon,
		header,
		description,
		pathName: 'https://www.folxhealth.com/library',
	};
};

export default Library;
